import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import type { Fond } from '../../types/Fond';
import { useFondByIdQuery } from '../../stores/OkOkStore';
import type { Transactions } from '../../types/Transaction';
import { useTrads } from "../../contexts/trads/useTrads";

function FondBarChart({fond}:{fond:Fond}){
    const { data, error, isLoading } = useFondByIdQuery(fond.id.toString());

    const positifs=data?.transactions?.filter((e:Transactions)=>e.montant > 0).reduce((acc:number,e:Transactions)=>acc+e.montant,0)??0;
    const negatifs=data?.transactions?.filter((e:Transactions)=>e.montant < 0).reduce((acc:number,e:Transactions)=>acc+e.montant,0)??0;
    const {translate}=useTrads();
    const users:Record<string,number>={};
    const chartdata=[];
    const chartbar:Record<string,number|string>={
            name:fond.name,
            disponible:positifs + negatifs,
            sortie:-1* negatifs,
        }
    data?.transactions?.forEach((e:Transactions)=>{
        if (e.demande){
            if(e.demande.inscription){
                users[e.demande.inscription.identifiant??0]=(users[e.demande.inscription.identifiant??0]??0) + e.demande.montant;
            }
        }
    });
    for (const i of Object.keys(users)){
        chartbar[i]=users[i];
    }
    chartdata.push(chartbar);

    const usersColors=[
      "#a44e6f",
      "#7bb743",
      "#a25aca",
      "#61be84",
      "#ca49a1",
      "#407e44",
      "#6369c7",
      "#d09d3b",
      "#668fcc",
      "#cb542f",
      "#40bec1",
      "#d94568",
      "#89833b",
      "#ce8ac8",
      "#c97c5f"
    ];

   

    return (
        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
        <div className="fond-chart">
            

            <BarChart width={550} height={500}
               
                //layout="vertical"
                data={chartdata}
                margin={{
                    top: 20,
                    right: 0,
                    left: 60,
                    bottom: 5,
                }}
                >
                <CartesianGrid   />
                <XAxis dataKey="name" />
                <YAxis width="auto"  />
                <Tooltip />
                <Legend />

                {Object.keys(users).map((e,index)=>(
                    <Bar key={e} dataKey={e} stackId="a" fill={usersColors[index]}  />
                ))}
                <Bar dataKey="disponible" stackId="a" fill="#82ca9d"  />                

                
                
                
                
            </BarChart>
        </div>
        ):null
  );
}

export default FondBarChart;